import type { GetStaticProps, InferGetStaticPropsType } from 'next';
import { NextSeo } from 'next-seo';

import NoSSR from '../../components/no-ssr';

import PDF from './document';
import type { PageProps } from './types';

export default function makeDocPage<GetStaticPropsType extends GetStaticProps<PageProps>>() {
  return function DocPage({ metaTitle, metaDescription, file }: InferGetStaticPropsType<GetStaticPropsType>) {
    return (
      <>
        <NextSeo title={metaTitle} description={metaDescription} />
        <NoSSR>
          <PDF src={file.href} />
        </NoSSR>
      </>
    );
  };
}
